module.exports = __webpack_public_path__ + "../resources/img/editing.3705724d.png";